import {
	GET_ALL_SIZES,
	SAVE_SIZE,
	DELETE_SIZE
} from '../../Actions/Admin/ManageSizeAction';

const initialState = {
	sizes: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ALL_SIZES:
			return {
				...state,
				loading: true,
				sizes: action.payload
			};
		
		case SAVE_SIZE:
			return {
				...state,
				sizes: action.payload
			};
		case DELETE_SIZE:
			return {
				...state,
				sizes: action.payload
			};
		default:
			return state;
	}
};
